<h3>Möchten Sie den Benutzer Wirklich löschen?</h3>

<div style="margin: 2em 0; display: flex; flex-flow: column wrap; align-content: center; gap: 3em">

	<div style="display: flex; flex-flow: row wrap; gap: 2em">

		<button
			mat-raised-button
			style="flex-grow: 1;"
			color="warn"
			(click)="dialogRef.close(true)"
		>
			Ja
		</button>

		<button
			mat-raised-button
			(click)="dialogRef.close(false)"
		>
			Nein
		</button>

	</div>

</div>
